import * as Ariakit from '@ariakit/react';
import { forwardRef } from '@wordpress/element';
import { useCompositeContext } from './context';
import { jsx as _jsx } from "react/jsx-runtime";
export const CompositeTypeahead = forwardRef(function CompositeTypeahead(props, ref) {
  const context = useCompositeContext();

  // @ts-expect-error The store prop is undocumented and only used by the
  // legacy compat layer. The `store` prop is documented, but its type is
  // obfuscated to discourage its use outside of the component's internals.
  const store = props.store ?? context.store;
  return /*#__PURE__*/_jsx(Ariakit.CompositeTypeahead, {
    store: store,
    ...props,
    ref: ref
  });
});